import { tr } from "../lib/i18n";
import { MyPlanPanel } from "../components/MyPlanPanel";

export default function MyPlanPage() {
  return (
    <div data-testid="my-plan-page" className="max-w-3xl">
      <h1 className="mb-6" style={{ fontSize: 34, fontWeight: 600, letterSpacing: "-0.02em" }}>{tr("lic.my_plan")}</h1>
      <div className="panel p-6"><MyPlanPanel /></div>
    </div>
  );
}
